(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["auzi-cart-device"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('auzi-cart-device')) {

    const brandKey = value =>
      String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');

    let brandCatalogue;


    function loadCartBrands() {

      if (!brandCatalogue) {

        const element =
          document.querySelector(
            'auzi-device-picker [data-config]'
          );

        if (!element) {
          return Promise.resolve(null);
        }

        const config =
          JSON.parse(
            element.textContent
          );

        brandCatalogue =
          fetch(config.catalogueUrl)
            .then(response =>
              response.ok
                ? response.json()
                : Promise.reject()
            )
            .then(catalogue => ({
              brands:
                catalogue.brands || [],
              base:
                new URL(
                  config.assetBase,
                  location.href
                )
            }))
            .catch(() => {
              brandCatalogue = null;
              return null;
            });
      }

      return brandCatalogue;
    }


    customElements.define(
      'auzi-cart-device',
      class extends HTMLElement {

        async connectedCallback() {

          if (
            this.dataset.logoReady ||
            !this.dataset.brand
          ) {
            return;
          }

          const catalogue =
            await loadCartBrands();

          if (
            !catalogue ||
            !this.isConnected
          ) {
            return;
          }

          const brand =
            catalogue.brands.find(
              item =>
                brandKey(item.name) ===
                brandKey(
                  this.dataset.brand
                )
            );

          const badge =
            this.querySelector(
              '[data-cart-brand]'
            );

          if (
            !brand?.logo ||
            !badge
          ) {
            return;
          }

          this.dataset.logoReady =
            'true';

          const image =
            new Image(
              76,
              20
            );

          image.alt =
            brand.name;

          image.decoding =
            'async';

          image.onload = () => {

            badge.hidden =
              false;

            const fallback =
              this.querySelector(
                '[data-cart-brand-name]'
              );

            if (fallback) {
              fallback.hidden =
                true;
            }

          };

          image.onerror = () => {
            badge.hidden =
              true;
          };

          badge.dataset.brand =
            brandKey(
              brand.name
            );

          badge.dataset.dark =
            String(
              Boolean(
                brand.darkLogo
              )
            );

          badge.replaceChildren(
            image
          );

          image.src =
            new URL(
              brand.logo,
              catalogue.base
            ).href;

        }

      }
    );

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["auzi-device-summary"] && !Shopify.designMode) return;
  try {
    async function loadAuziDeviceSurfaces() {
    const config = document.querySelector('auzi-device-picker [data-config]');
    if (!config) return;
    const base = new URL(JSON.parse(config.textContent).assetBase, location.href);
    await import(new URL('auzi-device-surfaces.js?v=home-device-4', base).href);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadAuziDeviceSurfaces, { once: true });
  else loadAuziDeviceSurfaces();
  } catch(e) { console.error(e); }
})();

})();
